export default __webpack_public_path__ + "static/media/RedHatDisplay-Bold.b919dc18.woff";